<template>
  <div class="container">
    <div class="info">
      <!-- 标题 -->
      <div class="toptitle">{{ $t('property').title }}</div>
      <!-- 资产 -->
      <div class="balanceInfo">
        <!-- 可用资产 -->
        <div class="txt">{{ $t('property').availableassets }}</div>
        <div class="num">${{ propertyVo.balance.toFixed(2).replace(/\.?0+$/, '') }}</div>
        <!-- 总资产 盈亏 持仓资产 保证金 -->
        <div class="btxt"><span>{{ $t('property').totalassets }}</span><span>{{ $t('property').profitloss
            }}</span><span>{{ $t('property').Holdingassets }}</span><span>{{ $t('property').margin }}</span></div>
        <div class="bnum"><span>${{ propertyVo.totalAmount.toFixed(2).replace(/\.?0+$/, '') }}</span><span>${{
          propertyVo.profitAmount.toFixed(2).replace(/\.?0+$/, '') }}</span><span>${{
              propertyVo.positionAmount.toFixed(2).replace(/\.?0+$/, '') }}</span><span>${{
              propertyVo.marginAmount.toFixed(2).replace(/\.?0+$/, '') }}</span></div>
      </div>
      <!-- 收益情况 -->
      <!-- <div class="title">最近一周收益情况</div>
    <div class="info" id="income">
    </div> -->
      <!-- 投资组合 -->
      <div class="title">{{ $t('property').investmentportfolio }}</div>
      <div class="info" id="combination">
      </div>
      <!-- 收益列表 -->
      <div class="title">{{ $t('property').Recentincomesituation }}<span
          @click="$router.push({ name: 'PropertyList' })">{{ $t('property').Seemore }}</span></div>
      <!-- 列表 -->
      <div class="listInfo">
        <div class="item" v-for="(dItem, dIndex) in oList" :key="`po${dIndex}`">
          <div class="name"> {{ dItem.productName }} <span class="amount red" v-if="dItem.profitAmount < 0">-${{
            -dItem.profitAmount }}</span>
            <span class="amount green" v-else>+${{ dItem.profitAmount }}</span>
          </div>
          <div class="time">{{ dItem.createTime | getLocalTime }} <span>-</span> <span>{{ dItem.salesTime | getLocalTime
              }}</span></div>
          <div class="order" v-if="dItem.orderNo">{{ dItem.orderNo }} <span @click="onCopy(dItem.orderNo)">{{
            $t('public').copyTxt }}</span>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import userApi from '@/api/user'
import orderApi from '@/api/order'
export default {
  components: {
  },
  data() {
    return {
      propertyVo: { totalAmount: 0, profitAmount: 0, positionAmount: 0, marginAmount: 0, balance: 0 },
      parms: {
        pageNum: 1,
        pageSize: 10,
      },
      oList: [],
      //  产品类型(1数字货币2外汇3期货4股指5股票)
      productTypeArrs: [
        {
          Id: '1',
          Name: this.$t('public').DigitalCurrency
        },
        {
          Id: '2',
          Name: this.$t('public').foreignExchange
        },
        {
          Id: '3',
          Name: this.$t('public').futures
        },
        {
          Id: '4',
          Name: this.$t('public').stockIndex
        },
        {
          Id: '5',
          Name: this.$t('public').stock
        },
      ],
    }
  },
  mounted() {
    this.getPropertyInfo()
    // this.getIncome()
    this.getCombination()
    this.getOrderList()
  },
  methods: {
    // 获取收益情况
    getIncome() {
      // 获取 CSS 变量的值
      const textColor = getComputedStyle(document.documentElement).getPropertyValue('--text_color');
      var chartDom = document.getElementById('income');
      var myChart = this.$echarts.init(chartDom)
      var option = {
        xAxis: {
          type: 'category',
          data: ['09.24', '09.25', '09.26', '09.27', '09.28', '09.29', '09.30'],
          axisLabel: {
            interval: 0 // 显示所有的x轴标签
          },
          axisLine: {
            onZero: false,
            show: true, // 这里设置为 false 隐藏 x 轴线
            lineStyle: {
              color: '#64748B',
              opacity: 0.5,
              width: 1,
              type: 'solid'
            }
          },
        },
        yAxis: {
          type: 'value',
          show: false // 隐藏Y轴
        },
        series: [
          {
            data: [1500, -200, 150, 80, 70, 110, 130],
            type: 'bar',
            itemStyle: {
              barBorderRadius: [5, 5, 5, 5],
              color: function (params) {
                // 根据数值的正负返回不同的颜色
                return params.value > 0 ? '#00CDCF' : '#F65A5A';
              }
            },
            label: {
              show: true, // 显示文字
              position: 'top', // 在顶部显示
              formatter: '${c}', // 文字内容，{c} 表示数值
              color: textColor, // 文字颜色
              fontSize: 13, // 文字大小
            }
          }
        ]
      };
      myChart.setOption(option);
    },
    // 获取投资组合
    async getCombination() {
      var data = []
      const res = await userApi.getCombination()
      var resData = res.combination
      if (Object.keys(resData).length > 0)
        for (let key in resData) {
          data.push({ value: resData[key], name: this.productTypeArrs.filter(item => item.Id == key)[0].Name })
        }
      else
        data = [{ value: 0 }]
      // 获取 CSS 变量的值
      const textColor = getComputedStyle(document.documentElement).getPropertyValue('--text_color');
      var chartDom = document.getElementById('combination');
      var myChart = this.$echarts.init(chartDom)
      var option = {
        tooltip: {
          trigger: 'item'
        },
        legend: {
          top: 'bottom',
          textStyle: {
            color: textColor
          }
        },
        series: [
          {
            type: 'pie',
            // radius: '80%',
            radius: [20, 130],
            data: data,
            avoidLabelOverlap: false,
            padAngle: 3,
            itemStyle: {
              borderRadius: 5
            },
            label: {
              show: true,
              position: 'inside', // 标签的位置设置为扇区内部
              formatter: '{percent|{d}%}\n{name|{b}}', // 标签的格式化
              rich: {
                percent: {
                  color: textColor, // 设置百分比文字的颜色为红色
                  fontSize: 13, // 设置百分比文字的大小
                  align: 'center', // 文字水平居中
                  verticalAlign: 'middle' // 文字垂直居中
                },
                name: {
                  color: textColor, // 设置数据项名称文字的颜色为蓝色
                  fontSize: 11, // 设置数据项名称文字的大小
                  align: 'center', // 文字水平居中
                  verticalAlign: 'middle' // 文字垂直居中
                }
              }
            },
            labelLine: {
              show: false // 不显示指引线
            },
          }
        ]
      };
      myChart.setOption(option);
    },
    // 获取资产统计
    async getPropertyInfo() {
      const res = await userApi.getPropertyInfo()
      this.propertyVo = res.property
    },
    // 获取平仓订单列表
    async getOrderList() {
      this.parms.status = '3'
      const res = await orderApi.getOrderList(this.parms)
      this.oList = res.rows;
    },
    //复制方法
    onCopy(text) {
      return new Promise((resolve) => {
        if (navigator.clipboard?.writeText) {
          this.$toast(this.$t('public').copySuccess)
          return resolve(navigator.clipboard.writeText(text))
        }
        const textarea = document.createElement('textarea')
        document.body.appendChild(textarea)
        textarea.style.position = 'absolute'
        textarea.style.clip = 'rect(0 0 0 0)'
        textarea.value = text
        textarea.select()
        document.execCommand('copy', true)
        textarea.remove()
        this.$toast(this.$t('public').copySuccess)
        return resolve(true)
      })
    },
  }
}
</script>

<style lang="less" scoped>
.container {
  min-height: 100vh;
  padding-top: 110px;
  margin-bottom: -60px;
  width: 100%;
  background: var(--background_color);

  .info {
    margin: 0 auto;
    max-width: 1280px;

    .toptitle {
      font-size: 48px;
      font-weight: bold;
      color: var(--text_color);
    }

    .balanceInfo {
      margin-top: 30px;
      background: linear-gradient(180deg, rgba(108, 77, 218, 1) 0%, #522ED2 100%);
      border-radius: 15px;
      padding: 20px;

      .txt {
        margin-bottom: 10px;
        font-size: 14px;
        color: #fff;
      }

      .num {
        font-weight: bold;
        font-size: 25px;
        color: #fff;
        margin-bottom: 15px;
      }

      .btxt {
        margin-bottom: 10px;
        font-size: 14px;
        color: #fff;
        display: flex;
        justify-content: space-between;

        span {
          width: 25%;
        }
      }

      .bnum {
        font-weight: bold;
        font-size: 18px;
        color: #fff;
        display: flex;
        justify-content: space-between;

        span {
          width: 25%;
        }
      }

    }

    .title {
      margin: 30px 0 0 5px;
      display: flex;
      justify-content: space-between;
      align-items: center;
      font-weight: bold;
      font-size: 25px;
      color: var(--text_color);

      span {
        font-size: 16px;
        color: #64748B;
      }
    }

    .info {
      margin-top: 20px;
      background: var(--info_color);
      border-radius: 15px;
      width: 100%;
      height: 430px;
      padding-bottom: 50px;
    }

    .listInfo {
      padding-bottom: 80px;

      .item {
        padding: 15px;
        background: var(--info_color);
        border-radius: 10px;
        margin-top: 15px;

        .name {
          display: flex;
          justify-content: space-between;
          font-size: 20px;
          color: var(--text_color);
        }

        .time {
          margin-top: 10px;
          font-size: 15px;
          color: #64748B;
          display: flex;
          justify-content: space-between;
          align-items: center;
        }

        .order {
          display: flex;
          justify-content: space-between;
          align-items: center;
          margin-top: 10px;
          font-size: 15px;
          color: #64748B;

          span {
            color: var(--primary_color);
          }
        }
      }
    }
  }
}
</style>
